import { Button, Card, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { SettingContext } from "../../routes";
import { downloadCSV, formatDate, getUserRole } from "../../services/util";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import { callLogColumns } from "./columns";

function CallLog() {
    const navigate = useNavigate();
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);

    const { selectedDates, setSelectedHotels, selectedHotels } =
        useContext(SettingContext);
    const hotel_ids = selectedHotels;

    const [start_date, end_date] = selectedDates;
    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: "call_logs_count",
    });

    const [formData, setFormData] = useState({
        data_for: "call_logs",
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        page: 0,
        limit: 10,
        hotel_type: "all",
        staff_id,
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    });
    const {
        status: pbxCallStatus,
        data: pbxCallStatusRes,
        refetch: fetchPbxCallCount,
    } = useQuery(
        "pbxCallStatusTable",
        async () => {
            return await HTTP("/dashboard/getDashboardData", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchPbxCallCount();
    }, []);

    useEffect(() => {
        fetchPbxCallCount();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        if (pbxCallStatus === "success") {
            const { data: callLogData, total } = pbxCallStatusRes;
            setTotalRecords(total);
            setTableData(callLogData);
        }
    }, [pbxCallStatus, pbxCallStatusRes]);

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }

        const newFormData = {
            ...formData,
            ...others,
        };

        setFormData(newFormData);
    }

    function getHotelWiseData(e) {
        const hotel_id = e.currentTarget.getAttribute("id");
        return navigate(`/call-log/${hotel_id}`);
    }

    async function downalodReport() {
        const tempFormData = { ...formData };
        delete tempFormData["page"];
        delete tempFormData["limit"];
        const res = await HTTP("/dashboard/getDashboardDataReport", {
            ...tempFormData,
        });
        downloadCSV(res, `calllog_reports`);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    (getUserRole() == "Super Admin" ||
                        getUserRole() == "Admin" ||
                        getUserRole() == "Management") && (
                        <Button
                            type="primary"
                            className="margin-right-5"
                            onClick={downalodReport}
                        >
                            Download
                        </Button>
                    )
                }
            />
            <Card className="box-shadow margin-10">
                {pbxCallStatus === "loading" || pbxCallStatus === "idle" ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={callLogColumns(getHotelWiseData, sortedInfo)}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="hotel_id"
                    />
                )}
            </Card>
        </Card>
    );
}

export { CallLog };
